import {
  FaFolder, FaFileImage, FaFileVideo, FaFileAudio, FaFilePdf, FaFileWord,
  FaFileExcel, FaFilePowerpoint, FaFileArchive, FaFileAlt
} from 'react-icons/fa'

export const formatBytes = (bytes) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return ''
  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let n = Number(bytes)
  let i = 0
  while (n >= 1024 && i < units.length - 1) { n /= 1024; i++ }
  return `${i > 0 && n < 10 ? n.toFixed(1) : Math.round(n)} ${units[i]}`
}

export const extensionOf = (name) => {
  const m = /\.([^.]+)$/.exec(name || '')
  return m ? m[1].toLowerCase() : ''
}

const KINDS = {
  image: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif', 'tif', 'tiff', 'bmp', 'svg', 'psd', 'ai', 'eps', 'raw', 'cr2', 'nef', 'arw', 'dng'],
  video: ['mp4', 'mov', 'm4v', 'avi', 'mkv', 'webm', 'wmv', 'mpg', 'mpeg'],
  audio: ['mp3', 'wav', 'aac', 'm4a', 'aiff', 'aif', 'flac', 'ogg'],
  pdf: ['pdf'],
  word: ['doc', 'docx', 'odt', 'pages', 'rtf', 'txt', 'md'],
  sheet: ['xls', 'xlsx', 'csv', 'ods', 'numbers'],
  slides: ['ppt', 'pptx', 'odp', 'key'],
  archive: ['zip', 'rar', '7z', 'tar', 'gz']
}

export const fileKind = (name) => {
  const ext = extensionOf(name)
  return Object.keys(KINDS).find(k => KINDS[k].includes(ext)) || 'file'
}

const ICONS = {
  folder: [FaFolder, '#d9a441'],
  image: [FaFileImage, '#2b7a78'],
  video: [FaFileVideo, '#7b4fa0'],
  audio: [FaFileAudio, '#c0612b'],
  pdf: [FaFilePdf, '#c0392b'],
  word: [FaFileWord, '#2b579a'],
  sheet: [FaFileExcel, '#217346'],
  slides: [FaFilePowerpoint, '#d24726'],
  archive: [FaFileArchive, '#6f7a73'],
  file: [FaFileAlt, '#6f7a73']
}

export const ItemIcon = ({ item, size = 18 }) => {
  const kind = item.kind === 'folder' ? 'folder' : fileKind(item.name)
  const [Icon, color] = ICONS[kind]
  return <Icon size={size} color={color} style={{ flexShrink: 0 }} />
}

export const typeLabel = (item) => {
  if (item.kind === 'folder') return 'Folder'
  return extensionOf(item.name).toUpperCase() || 'File'
}

// Formats the browser can render in a tab; everything else is download-only.
export const canOpenInline = (name) => {
  const kind = fileKind(name)
  if (['image', 'video', 'audio', 'pdf'].includes(kind)) {
    return !['heic', 'heif', 'psd', 'ai', 'eps', 'raw', 'cr2', 'nef', 'arw', 'dng', 'tif', 'tiff', 'avi', 'mkv', 'wmv', 'mpg', 'mpeg', 'aiff', 'aif'].includes(extensionOf(name))
  }
  return ['txt', 'md', 'csv'].includes(extensionOf(name))
}

// The shared axios instance resolves error responses instead of rejecting.
export const errorOf = (res, fallback = 'Something went wrong') => {
  if (!res) return 'Could not reach the server'
  if (res.status >= 400) return (res.data && res.data.error) || fallback
  return null
}
